export const ALL_PROJECT_TYPES = {
  label: 'All project types',
  value: 'all project types'
}
export const SYSTEM_TYPES_LABEL = {
  sconn: 'Sensor Connected Workplace',
  sctrl: 'Workplace Observation Study'
}
export const PROJECT_SYSTEM_TYPES = [{
  label: 'All project types',
  value: 'all project types'
}, {
  label: SYSTEM_TYPES_LABEL.sconn,
  value: 'sconn'
}, {
  label: SYSTEM_TYPES_LABEL.sctrl,
  value: 'sctrl'
}]
